"use client"

import { useEffect, useMemo,useRef } from "react"

import { processContentWithIds } from "@/lib/process-content"

interface BlogContentProps {
  content: string
  onHeadingsReady: (container: HTMLElement) => void;
}

export function BlogContent({ content, onHeadingsReady }: BlogContentProps) {
  const contentRef = useRef<HTMLDivElement>(null)

  const processedContent = useMemo(() => {
    return processContentWithIds(content)
  }, [content])

  useEffect(() => {
    if (!contentRef.current) return;

    onHeadingsReady(contentRef.current);
  }, [content, onHeadingsReady]);

  return (
    <div
      ref={contentRef}
      className="prose prose-invert max-w-none post-content mt-6"
      dangerouslySetInnerHTML={{ __html: processedContent }}
    />
  )
}
